import store from '../../../store/main';

function onRoleProjectCreated(event) {
  store.commit('roles/addProjectRole', { ...event.data });
}

export default onRoleProjectCreated;
